var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"index-section-layout",class:[
        {
        'index-section-layout--large': _vm.large,
        'index-section-layout--imaged': _vm.bgWithImage,
        'index-section-layout--call-to-action': _vm.isCallToAction
        },
        _vm.bgThemeClass
    ]},[(_vm.title.length)?_c('h2',{staticClass:"index-section-layout__title",class:_vm.titleBottomMarginClass},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }